import { Button, CircularProgress } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_URL } from "const/constants";
import useKothar from "context/useKothar";
import OtpInput from "react-otp-input";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { finishFirstLoginOtp } from "utils/postLoginNavigation";

export default function FirstLoginOTP() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const email = sessionStorage.getItem("pendingVerificationEmail") || "";
  const [, { setToken }] = useKothar();

  const { isLoading, mutate } = useMutation(
    async () => {
      const res = await axios.post(`${API_URL}/email/verify-login-otp`, {
        email,
        code: otp,
      });
      return res.data;
    },
    {
      onSuccess(data) {
        if (!data?.success) {
          toast.error("Invalid or expired OTP. Please try again.");
          return;
        }
        finishFirstLoginOtp(data, { navigate, setToken, email });
        sessionStorage.removeItem("pendingVerificationEmail");
      },
      onError() {
        toast.error("Verification failed. Please try again.");
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp.length < 6) return;
    mutate();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="mx-auto px-4 h-full w-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-3/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-app-surface-hover border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h3 className="text-app-text-muted text-xl font-bold uppercase">
                    Verify Your Email
                  </h3>
                  <p className="text-app-text-secondary text-sm mt-2">
                    We sent a 6-digit code to{" "}
                    <strong className="text-app-text">{email || "your email"}</strong>
                  </p>
                </div>

                <hr className="mt-6 border-b-1 border-app-border" />
              </div>

              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form className="space-y-6" onSubmit={handleSubmit}>
                  <div className="flex justify-center">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderSeparator={<span className="mx-1 text-app-text-muted">-</span>}
                      renderInput={(props) => (
                        <input
                          {...props}
                          className="h-11 w-10 sm:h-12 sm:w-12 rounded-lg border border-app-border bg-app-surface text-center text-lg font-semibold text-app-text focus:outline-none focus:ring-2 focus:ring-primary/30"
                        />
                      )}
                    />
                  </div>

                  <div className="text-center mt-6">
                    <Button
                      variant="contained"
                      className="w-full"
                      type="submit"
                      disabled={otp.length < 6 || isLoading}
                      startIcon={isLoading && <CircularProgress size={15} />}
                    >
                      {isLoading ? "Verifying…" : "Verify OTP"}
                    </Button>
                  </div>
                </form>
              </div>
            </div>

            <div className="flex flex-wrap mt-6 relative">
              <div className="w-full text-center">
                <Link to="/login" className="text-slate-200">
                  <small>Back to login</small>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
